/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable react/jsx-no-bind */
import { type FC, type MouseEvent } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { FilterLabel, mapFilterLabels, type SingleFilter } from '@vakantiesnl/components/src/atoms/FilterLabel';
import { type GeoState } from '@vakantiesnl/services/src/hooks/queries';
import { type FilterState, type RemoveFilterKey } from '@vakantiesnl/services/src/stores/filtersStore';
import { useGlobalFiltersStore } from '@vakantiesnl/services/src/stores/globalFiltersStore';
import { type MicroCopy } from '@vakantiesnl/types';

import { useStyles } from './FilterLabelList.style';

interface Props {
	filters: FilterState;
	onFilterRemove: (event: MouseEvent, filterType: RemoveFilterKey, value: string) => void;
	onClear: VoidFunction;
	microCopies: MicroCopy;
	geo: GeoState;
	isLoading: boolean;
}

export const FiltersLabels: FC<Props> = ({ filters, onFilterRemove, onClear, microCopies, geo, isLoading }) => {
	const { classes } = useStyles();
	const globalFilters = useGlobalFiltersStore((s) => s.filters);
	const filtersLabels = mapFilterLabels(filters, globalFilters, microCopies, geo);

	if (!filtersLabels.length) return null;

	return (
		<div className={classes.filterLabelListContainer}>
			<div data-cy="selected-filters" className={classes.selectedFilters}>
				{filtersLabels.map(({ filterType, filterLabel, value }: SingleFilter, index: number) => (
					<FilterLabel
						key={`${value}-${index}`}
						qaTagValue={`selected-filter-${index + 1}`}
						label={filterLabel}
						onCloseClick={(e): void => onFilterRemove(e, filterType as RemoveFilterKey, value)}
						disabled={isLoading}
					/>
				))}
				{!isLoading && (
					<Button
						className={classes.clearFilters}
						data-cy="clearFilters"
						onClick={onClear}
						variant="tertiary"
						size="small"
						aria-label={microCopies['filters.clear']}
					>
						{microCopies['filters.clear']}
					</Button>
				)}
			</div>
		</div>
	);
};
